import { createVanIconComponent } from "./van"

const ExpandOutlined = createVanIconComponent("expand-o")
export default ExpandOutlined
